/**
 * UI module
 */

import { getMutationsForScope, getActionsForScope } from '../utils';
import { FORCE_CONTEST_ACTIVE, CONTEST_ACTIVE_BEGIN, CONTEST_ACTIVE_END } from './../../config';

const mutation = getMutationsForScope('ui');
const action = getActionsForScope('ui'); // eslint-disable-line


const moduleState = {
  entryView: false,
  heroVideoExpanded: false,
};

const moduleGetters = {
  /**
   * is it time for the contest to start.
   * or are we forcing the contest to start.
   *
   * @returns {Bool}
   */
  contestActive(state, getters) {
    return (getters.pastStartTime && getters.beforeEndTime) || FORCE_CONTEST_ACTIVE;
  },

  /**
   * After content begins
   *
   * @returns {Boolean}
   */
  pastStartTime() {
    return Date.now() >= CONTEST_ACTIVE_BEGIN;
  },

  /**
   * Before contest ends
   *
   * @returns {Boolean}
   */
  beforeEndTime() {
    return Date.now() < CONTEST_ACTIVE_END;
  },

  /**
   * Show the countdown element
   *
   * @param {*} state
   * @param {*} getters
   * @returns {Boolean}
   */
  showCountdown(state, getters) {
    if (FORCE_CONTEST_ACTIVE) {
      return getters.beforeEndTime;
    }
    return !getters.contestActive && getters.beforeEndTime;
  }
};

const mutations = {
  [mutation.UI_SET_ENTRY_VIEW](state, { value }) {
    state.entryView = value;
  },
  [mutation.UI_HERO_VIDEO_VISIBLE](state, { visible }) {
    state.heroVideoExpanded = visible;
  }
};

const actions = {

};

export default {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  mutations,
  actions,
};
